import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@common/components';
import { cn } from '@core/utils';
import { useState } from 'react';
import { buildGiftHeroImageUrl } from '@/app/_components/GiftCard/giftImage';
import { Image } from '@/components/client';
import { BREAKPOINTS } from '@/constants/breakpoints';
import { useMediaQuery } from '@/hooks/useMediaQuery';
interface DesktopMainImagesProps {
  title: string;
  heroImageUrlList: string[];
  adultYN: boolean;
  thumbnailSrc?: string;
}
export const DesktopMainImages = t0 => {
  const $ = _c(30);
  const {
    title,
    heroImageUrlList,
    adultYN,
    thumbnailSrc
  } = t0;
  const isDesktopViewport = useMediaQuery(BREAKPOINTS.DESKTOP, false);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = new Set([0]);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [loadedImages, setLoadedImages] = useState(t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = index => {
      setSelectedImageIndex(index);
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const handleImageSelect = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = index_0 => {
      setLoadedImages(prev => new Set(prev).add(index_0));
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const handleImageLoad = t3;
  let t4;
  if ($[3] !== loadedImages || $[4] !== selectedImageIndex) {
    t4 = loadedImages.has(selectedImageIndex);
    $[3] = loadedImages;
    $[4] = selectedImageIndex;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const isCurrentImageLoaded = t4;
  const entryThumbnail = selectedImageIndex === 0 ? thumbnailSrc : undefined;
  let t5;
  if ($[6] !== entryThumbnail || $[7] !== heroImageUrlList || $[8] !== isCurrentImageLoaded || $[9] !== isDesktopViewport || $[10] !== selectedImageIndex || $[11] !== title) {
    t5 = isDesktopViewport || selectedImageIndex === 0 ? <>{!isCurrentImageLoaded && !entryThumbnail && <Skeleton className="absolute inset-0 size-full rounded-[48px]" />}<div className="relative size-full rounded-[48px]">{entryThumbnail ? <Image src={entryThumbnail} alt="" fill={true} unoptimized={true} className="rounded-[48px] object-cover object-center" loading="eager" /> : null}<Image key={selectedImageIndex} fill={true} preload={true} fetchPriority="high" alt={title || "\uC6F0\uB85C \uACE0\uD5A5\uC0AC\uB791\uAE30\uBD80 \uB2F5\uB840\uD488"} src={buildGiftHeroImageUrl(heroImageUrlList[selectedImageIndex])} unoptimized={true} className={cn("rounded-[48px] object-cover object-center transition-opacity duration-200", !isCurrentImageLoaded && "opacity-0")} onLoad={() => handleImageLoad(selectedImageIndex)} /></div></> : <Skeleton className="size-full rounded-[48px]" />;
    $[6] = entryThumbnail;
    $[7] = heroImageUrlList;
    $[8] = isCurrentImageLoaded;
    $[9] = isDesktopViewport;
    $[10] = selectedImageIndex;
    $[11] = title;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== adultYN) {
    t6 = adultYN && <div className="absolute left-20 top-20 rounded-xsmall bg-B-500 px-12 py-4 font-600 text-Gray-white typo-body4">19세이상 구매가능</div>;
    $[13] = adultYN;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t5 || $[16] !== t6) {
    t7 = <div className="relative mb-20 aspect-square">{t5}{t6}</div>;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== heroImageUrlList || $[19] !== selectedImageIndex || $[20] !== title) {
    let t9;
    if ($[22] !== selectedImageIndex || $[23] !== title) {
      t9 = (imageUrl, index_1) => <div key={index_1} className={cn("relative aspect-square w-full cursor-pointer overflow-hidden rounded-large", {
        "border-1 border-Gray-black": selectedImageIndex === index_1
      })} onClick={() => handleImageSelect(index_1)}><Image fill={true} loading="lazy" src={imageUrl} alt={title || "\uC6F0\uB85C \uACE0\uD5A5\uC0AC\uB791\uAE30\uBD80 \uB2F5\uB840\uD488"} sizes="(min-width: 1280px) 8vw" className="object-cover" /></div>;
      $[22] = selectedImageIndex;
      $[23] = title;
      $[24] = t9;
    } else {
      t9 = $[24];
    }
    t8 = heroImageUrlList.map(t9);
    $[18] = heroImageUrlList;
    $[19] = selectedImageIndex;
    $[20] = title;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[25] !== t8) {
    t9 = <div className="grid grid-cols-6 gap-10">{t8}</div>;
    $[25] = t8;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  let t10;
  if ($[27] !== t7 || $[28] !== t9) {
    t10 = <div className="mobile:hidden tablet:hidden">{t7}{t9}</div>;
    $[27] = t7;
    $[28] = t9;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  return t10;
};